import { render, staticRenderFns } from "./searchHeader.vue?vue&type=template&id=1d13b8ec&scoped=true"
import script from "./searchHeader.vue?vue&type=script&lang=js"
export * from "./searchHeader.vue?vue&type=script&lang=js"
import style0 from "./searchHeader.vue?vue&type=style&index=0&id=1d13b8ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d13b8ec",
  null
  
)

export default component.exports